import React, { useState, useEffect, useCallback, useContext } from 'react';
import { GermanArticleButtons } from './GrammarInputs';
import { DutchArticleButtons } from './GrammarInputs';
import StartButton from '../../buttons/StartButton.jsx';
import { API_URL } from '../../../config';
import { useAuth } from "react-oidc-context";
import { GameContext } from '../../../GameContext';

const ArticlesQuiz = ({onResultUpdate, shouldEnd, onEndComplete}) => {
    const auth = useAuth();
    const token = auth.user?.access_token;
    const [isGameActive, setIsGameActive] = useState(false)
    const [isAnswerSelected, setIsAnswerSelected] = useState(true);
    const [userInput, setUserInput] = useState('');
    const [question, setQuestion] = useState('');
    const [correctAnswer, setCorrectAnswer] = useState('');
    const [displayArticle, setDisplayArticle] = useState('____');
    const [answerResult, setAnswerResult] =useState(false);
    const { selectedLanguage, languageData, learnedWords, updateLearnedList, loadLanguageData, grammarQuestionsList, 
        learnedGrammarList, loadGrammarQuestions, loadUsersLearnedGrammar, updateLearnedGrammarList, languageTips } = useContext(GameContext);
    const selectedGrammarExercise = 'articles';

//need full handleGameStart function here see other grammar quizzes
    const handleGameStart = useCallback(async(started) => {
      if (started) {
    console.log('Starting new article session')
    console.log(selectedLanguage)
    try {
      const initResponse = await fetch(`${API_URL}/api/new-grammar-exercise`, {
        method: 'POST',
        credentials: 'include',
        headers: {'Content-Type': 'application/json',
                  'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ vocab_list: languageData,
          selected_grammar_exercise: selectedGrammarExercise }),
      });
      const initData = await initResponse.json();
      console.log("Aricles quiz initialized:", initData);
      loadUsersLearnedGrammar(initData.learnedGrammarList);
      loadGrammarQuestions(initData.grammarQuestionsList);
      console.log('length of noun file = ' + initData.grammarQuestionsList.length)

      setIsGameActive(true);
      setIsAnswerSelected(false);
      onResultUpdate('');
      const wordList = initData.grammarQuestionsList;
      const learnedWordList = initData.learnedGrammarList;
      await fetchNewWord(wordList, learnedWordList);
    } catch (error) {
      console.error('Error starting article quiz:', error);
      onResultUpdate({
        feedback: 'An error occurred while evaluating your article quiz answer. Please try again.'
      });
    }
    setIsAnswerSelected(false);
    }else {
    await endGame();
    }
    });

    const fetchNewWord = async (wordList = null, learnedWordList = null) => {
      console.log("Starting the articles game process");
      console.log("selected grammar exercise = "+ selectedGrammarExercise)
      console.log("length of noun file = " + (wordList ? wordList.length : 0));
      const listToUse = wordList || grammarQuestionsList;
      const learnedListToUse = learnedWordList || learnedGrammarList;
      console.log('length of listToUse = ' + listToUse.length)
      setIsAnswerSelected(false);  // Reset answer selected state first
      setUserInput(''); 
        try {
          const response = await fetch(`${API_URL}/api/generate-grammar-question`, {
            method: 'POST',
            credentials: 'include',
            headers: {'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({ 
              selected_grammar_exercise: selectedGrammarExercise,
              selected_grammar_questions_list: listToUse,
              learned_grammar_list: learnedListToUse
            }),
          });
          if (!response.ok) {
            throw new Error('Failed to fetch article question');
          }
          const data = await response.json();
          setCorrectAnswer(data.generatedAnswer);
          setQuestion(data.generatedQuestion);
          console.log(data.generatedQuestion)
        } catch (error) {
            console.log('Error fetching article question:');
          }
        setUserInput('');
        onResultUpdate({
          feedback: ''
        });
        setAnswerResult(false);
        setDisplayArticle('____');
    };

    const handleInputChange = (e) => {
      setUserInput(e.target.value);
    };


    const handleAnswerSelected = useCallback(async (userInput) => {
      console.log('Selected answer:', userInput);
      setIsAnswerSelected(true);
      console.log('length of learned list file = ' + (learnedGrammarList ? learnedGrammarList.length: 0));
      try {
        const response = await fetch(`${API_URL}/api/process-grammar-mc`, {
          method: 'POST',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify({
            userAnswer: userInput,
            correctAnswer: correctAnswer,
            word: question,
            grammarExercise: selectedGrammarExercise, 
            vocab_list: languageData,
            learned_grammar_list: learnedGrammarList,
            tips_list: languageTips
          }),
        });
    
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const result = await response.json();
        console.log("Evaluation articles result:", result);

        updateLearnedGrammarList(result.learned_list)
    
        onResultUpdate({
          tip: result.tip,
          feedback: result.result
        });
        setUserInput('');
        setDisplayArticle(correctAnswer + ' ');
        setAnswerResult(result.gotAnswerCorrect);
    
      } catch (error) {
        console.error('Error evaluating artciles answer:', error);
      }
    });

    const endGame = useCallback(async () => {
      console.log("Ending the article game process");
      if (!isGameActive) return;
    
      try {
        const response = await fetch(`${API_URL}/api/end-grammar-quiz`, {
          method: 'POST',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify({
            grammarExercise: selectedGrammarExercise, 
            learned_grammar_list: learnedGrammarList
          }),
        });
        if (!response.ok) {
          throw new Error('Failed to end article quiz on server');
        }
        const data = await response.json();
        console.log("Article result:", data);
    
        onResultUpdate({
          feedback: data.feedback,
          answersGiven: data.answersGiven
        });
        
    
      } catch (error) {
        console.error("Error ending article quiz on server:", error);
      } finally {
        setIsGameActive(false);
        setUserInput('');
        onEndComplete();
        setIsAnswerSelected(true);
      }
    }, [isGameActive, onResultUpdate, onEndComplete]);

    useEffect(() => {
      //used to fire when the quiz is switched to another grammar exercise
      if (shouldEnd) {
        console.log(`Running end game process for articles`);
        endGame();
        onEndComplete();
      }
    }, [shouldEnd, isGameActive, onEndComplete]);

    const QuestionDisplay = ({ question, displayArticle, answerResult }) => {
      const getColorClass = () => {
        if (answerResult) return 'success';
        return 'secondary';
      };

      const getTextClass = () => {
        if (answerResult) return 'fw-bold';
        return 'fw-bold fst-italic';
      };
    
      return (
        <p className="fs-2 text-center mb-0">
          <span className={`text-${getColorClass()} ${getTextClass()}`}>{question ? displayArticle : " "}</span>
          {question || " "}
        </p>
      );
    };

return(

<div className="card border-0">
      <div className="card-body">
      <h5 className="mb-2">
        {isGameActive ? (
            <span className="custom-text-primary">Select the correct definite article for the following noun:</span>
          ) : (
            <span className="custom-text-primary">Click Start to begin</span>
          )}
        <div style={{ marginBottom: '40px' }}></div>
        <QuestionDisplay 
          question={question}
          displayArticle={displayArticle}
          answerResult={answerResult} />
        <div style={{ marginBottom: '40px' }}></div>
      </h5>
        {selectedLanguage === "dutch" ?
        (<DutchArticleButtons 
        onSubmit={handleAnswerSelected}
        userInput={userInput}
        onInputChange={handleInputChange}
        isSubmitted={isAnswerSelected}/>)

        :(<GermanArticleButtons 
        onSubmit={handleAnswerSelected}
        userInput={userInput}
        onInputChange={handleInputChange}
        isSubmitted={isAnswerSelected}/>)}
      </div>
      <div class="d-flex justify-content-between">
      <button className="btn btn-success custom-next-button btn-block mt-2 w-75" 
              type="button" 
              id="continueButton"
              onClick={() => fetchNewWord()}    
              disabled={!isAnswerSelected || !isGameActive}>Continue</button>
        <StartButton
          onToggle={handleGameStart}
          id="grammarStartButton"  
          isStarted={isGameActive}
        />
    </div>
    </div>

);

};

export default ArticlesQuiz;